import { Component } from '@angular/core';

@Component({
  selector: 'app-construction-portal',
  templateUrl: './construction-portal.component.html',
  standalone: false,
})
export class ConstructionPortalComponent {}
